import { render } from "./EshopService.vue?vue&type=template&id=b28f442e&scoped=true"
import script from "./EshopService.vue?vue&type=script&lang=js"
export * from "./EshopService.vue?vue&type=script&lang=js"

import "./EshopService.vue?vue&type=style&index=0&id=b28f442e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28f442e"]])

export default __exports__